import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.directive('loading', (el, { expression }, { evaluate }) => {
    expression  = evaluate(expression)
    let element = document.getElementById(expression.id);

    element.innerHTML =
        `<div x-data="{loading: false}" x-show="loading"
              x-init="() => {
                  loading=true;
                  const imageObj = new Image();
                  imageObj.src   = '${el.src}';
                  const interval = setInterval(() => {
                      if(imageObj.complete){
                          clearInterval(interval)
                          window.dispatchEvent(new CustomEvent('${expression.event}'));
                          loading = false;
                      }
                    }, 500)
              }"
              class="z-100 w-full h-1 bg-gray-200">
              <div class="bg-blue-500 p-0.5 leading-none progress-bar"></div>
         </div>`;
})
